module.exports = __webpack_public_path__ + "img/4.f57c7c6c.webp";